import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { Team } from '@/modules/team/models/Team';
import { TeamType } from '@/modules/team/enums/TeamType';

export class TeamCollection extends ModelCollection<Team> {
  constructor(items: Team[] | null = null) {
    super(items, Team);
  }

  static mapModel(items: Team[] | null = null): TeamCollection {
    return new this(items);
  }

  get accountantTeams(): Team[] | undefined {
    return this.items?.filter((team: Team): boolean => team.type === TeamType.ACCOUNTANT.key);
  }

  get juniorEstateProfessionalTeams(): Team[] | undefined {
    return this.items?.filter(
      (team: Team): boolean => team.type === TeamType.JUNIOR_ESTATE_PROFESSIONAL.key
    );
  }
}
